export default __webpack_public_path__ + "static/media/417.7f4c6f52.jpg";